import { GivelifyLink } from '@givelify/givelify-ui';
import { styled } from '@mui/material';

export const DownloadLink = styled(GivelifyLink)({
    display: 'flex',
    '& > :hover': {
        textDecoration: 'none',
    },
});
